const cta = document.querySelector('.phone-cta');

window.addEventListener('scroll', function () {
  let scrollY = window.scrollY;
  if (scrollY >= 100) {
    cta.classList.add('is-active');
  } else {
    cta.classList.remove('is-active');
  }
});
